import { FC, memo, useState } from 'react';

import { Box, Tooltip } from '@mui/material';

import { ArtworkThumbnail } from '@/features/media/ui/TableCellFilesPreview/TableCellFilesPreview.styles';
import { ImageResource, useResourceImage } from '@/shared/lib/hooks/useResourceImage';

interface ThumbnailItemProps {
  resource: ImageResource;
  fileName: string;
  onClick: () => void;
}

const ThumbnailItemImpl: FC<ThumbnailItemProps> = ({ resource, fileName, onClick }) => {
  const [previewRequested, setPreviewRequested] = useState(false);
  const { url: thumbUrl } = useResourceImage(resource, { size: { tier: 'thumb' } });
  const { url: previewUrl } = useResourceImage(resource, {
    size: { tier: 'preview' },
    enabled: previewRequested,
  });

  const tooltipSrc = previewUrl ?? thumbUrl;

  return (
    <Tooltip
      placement="top"
      enterDelay={150}
      onOpen={() => setPreviewRequested(true)}
      title={
        tooltipSrc ? (
          <Box
            component="img"
            src={tooltipSrc}
            alt={fileName}
            sx={{ width: '200px', height: 'auto' }}
          />
        ) : null
      }
    >
      <ArtworkThumbnail
        data-testid="artwork-thumbnail"
        src={thumbUrl ?? undefined}
        alt={fileName}
        onClick={onClick}
      />
    </Tooltip>
  );
};

const ThumbnailItem = memo(ThumbnailItemImpl);

export default ThumbnailItem;
